import React from 'react'
import BaseComponent from './BaseContainer'
import { graphql, compose, withApollo } from 'react-apollo'
import { Redirect } from 'react-router'
import Medias from '../components/list/Medias'
import getMedias from '../apollo/graphql/media/getMedias'
import getMedia from '../apollo/graphql/media/get'
import createMedia from '../apollo/graphql/media/create'
import deleteMedia from '../apollo/graphql/media/delete'
import updateMedia from '../apollo/graphql/media/update'
import searchMedia from '../apollo/graphql/media/search'

class MediasContainer extends BaseComponent {
  constructor(props) {
    super(props)

    this.state = {
      status: {
        loading: true,
        loadingMedias: false,
        message: null,
        error: null,
        deletion: { confirm: false }
      },
      redirect: false,
      obj: {
        name: ''
      },
      isSearch: '',
      deleteId: null,
      medias: [],
      dropzone: {
        files: []
      }
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleDrop = this.handleDrop.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    this.props.client.query({
      query: getMedias
    }).then(({ data }) => {
      if (getMedia.error) {
        this.setState({
          status: {
            ...this.state.status,
            error: true, message: getMedia.error.message
          }
        })
      }

      let newState = {
        ...this.state,
        medias: data.getMedias
      }
      newState.status.loading = false
      this.setState(newState)
    })
  }

  handleDrop (acceptedFiles, rejectedFiles) {
    this.setState({
      dropzone: {
        ...this.state.dropzone,
        files: acceptedFiles
      }
    })

    acceptedFiles.forEach(file => {
      this.props.createMedia({
        variables: {
          file: file
        }
      }).then((data) => {
        this.props.client.query({
          query: getMedias
        }).then(({ data }) => {
          if (getMedia.error) {
            this.setState({
              deleteId: null,
              status: {
                ...this.state.status,
                error: true, message: getMedia.error.message
              }
            })
          }

          this.setState({
            deleteId: null,
            medias: data.getMedias,
            obj: null,
            status: {
              ...this.state.status,
              loading: false
            }
          })
        })
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
    })
  }

  // Set obj in state with current data after open modal for edit
  handleOpenModal(event, data) {
    this.setState({
      obj: data
    })
  }

  handleChange(event, data, type) {
    let obj = {...this.state.obj}
    obj[data.id] = data.value

    this.setState({
      obj: obj
    })
  }

  handleSearch (e, data) {
    this.setState({
      ...this.state,
      isSearch: (data.value) ? data.value : '',
      status: {
        ...this.state.status,
        loadingMedias: true
      }
    })

    this.props.client.query({
      query: searchMedia,
      variables: {
        q: data.value
      }
    }).then((response) => {
      this.setState({
        isSearch: (data.value) ? data.value : '',
        medias: response.data.searchMedias,
        status: {
          ...this.state.status,
          loadingMedias: false
        }
      })
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.setState({
      status: {
        ...this.state.status,
        loading: true
      }
    })

    const { id, name } = this.state.obj

    this.props.updateMedia({
      variables: {
        id: id,
        input: {
          name: name
        }
      }
    }).then((data) => {
      const obj = data.data.updateMedia
      this.props.client.query({
        query: getMedias
      }).then(({ data }) => {
        if (getMedia.error) {
          this.setState({
            status: {
              ...this.state.status,
              error: true, message: getMedia.error.message
            }
          })
        }

        this.setState({
          medias: data.getMedias,
          obj: obj,
          status: {
            ...this.state.status,
            loading: false
          }
        })
      })
    }).catch((error) => {
      this.setState({
        status: {
          ...this.state.status,
          loading: false,
          message: error.message,
          error: true
        }
      })
    })
  }

  handleDelete(event, data) {
    event.preventDefault()

    let deleteId = this.state.deleteId

    if(data.id && !this.state.deleteId) {
      this.setState({ deleteId: data.id })
      deleteId = data.id
    }

    let newState = {
      deleteId: deleteId,
      status: {
        ...this.state.status,
        deletion: {}
      }
    }
    switch (data.confirm) {
    case true:
      newState.status.deletion.confirm = true
      break
    case null:
      newState.status.deletion.confirm = false
      break
    case false:
      newState.status.deletion.confirm = false
      this.props.deleteMedia({ variables: { id: newState.deleteId } }).then(({ data }) => {
        this.props.client.query({
          query: getMedias
        }).then(({ data }) => {
          if (getMedia.error) {
            this.setState({
              deleteId: null,
              status: {
                ...this.state.status,
                error: true, message: getMedia.error.message
              }
            })
          }

          this.setState({
            deleteId: null,
            medias: data.getMedias,
            obj: null,
            status: {
              ...this.state.status,
              loading: false
            }
          })
        })
      }).catch((error) => {
        this.setState({
          deleteId: null,
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
      break
    default:
      break
    }
    this.setState(newState)
  }

  handleClick(event, media) {
    if (this.props.handleClick) {
      this.props.handleClick(event, media)
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/medias'/>
    }

    if (this.state.status.loading) {
      return <div>Chargement</div>
    }

    return (
      <Medias
        obj={this.state.obj}
        medias={this.state.medias}
        dropzone={this.state.dropzone}
        status={this.state.status}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
        onOpenModal={this.handleOpenModal}
        onDrop={this.handleDrop}
        onClick={this.handleClick}
        onSearch={this.handleSearch}
        isSearch={this.state.isSearch}
      />
    )
  }
}

const MediasContainerEnhanced = compose(
  graphql(updateMedia, { name: 'updateMedia' }),
  graphql(createMedia, { name: 'createMedia' }),
  graphql(deleteMedia, {
    name: 'deleteMedia',
    options: {
      update: (proxy, { data }) => {
        const medias = proxy.readQuery({ query: getMedias })
        medias.getMedias = medias.getMedias.filter(obj => obj.id !== data.deleteMedia.id)
        proxy.writeQuery({ query: getMedias, data: medias })
      }
    }
  })
)(MediasContainer)

export default withApollo(MediasContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/MediasContainer.js